module.exports = __webpack_public_path__ + "static/media/hero.a43f8ac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero.jpg
// module id = 169
// module chunks = 0